module.exports = __webpack_public_path__ + "img/favicon.b7d5c6c7.ico";